export default "__VITE_ASSET__669b803b__"